import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Awareness } from './components/Awareness';
import { About } from './components/About';
import { WaysToWork } from './components/WaysToWork';
import { Testimonials } from './components/Testimonials';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-rise-black text-rise-white selection:bg-rise-gold/30" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <Awareness data-id="element-3" />
      <About data-id="element-4" />
      <WaysToWork data-id="element-5" />
      <Testimonials data-id="element-6" />
      <FinalCTA data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}